<template>
    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center my-lg p-lg bg-white shadow rounded-xl">
        <div>
            Med markerade ({{ selectedAddresses.length }} st):
        </div>
        <div class="flex mt-sm sm:mt-0">
            <move-selected-addresses
                :project="project"
                :projects="projects"
                :selected-addresses="selectedAddresses"
                route-name="api.delivery-projects.move-selected-addresses.store"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
            projects: {
                type: Object,
                required: true,
            },
            selectedAddresses: {
                required: true,
                type: Array,
            },
        },
    };
</script>
